import React from 'react'
import ScoringTest from '../components/test/ScoringTest'

const ScoringTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ScoringTest />
    </div>
  )
}

export default ScoringTestPage